import React from 'react';

const ProjectCard = ({ data }) => (
  <div className="project-card">
    <img className="project-img" alt="project demo" src={data.image} />
    <div className="info-div">
      <div className="info-menu">
        <h4> {data.name} </h4>
        <a
          href={data.url}
          className="project-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-github" aria-hidden="true"></i>
          Github{' '}
        </a>
      </div>
      <p className="project-info"> {data.info}</p>
      <small className='project-stack'>Stack:  [ {data.stack} ]</small>
    </div>
  </div>
);

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/componets/ProjectCard.js